export const TablePaginatorOptions = {
  rowsPerPageDefault: 20,
  rowsPerPageOptions: [20, 50, 100],
};
